module.exports = __webpack_public_path__ + "static/media/w_y_12.393b6fe2.png";